import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setIsRealEstate } from "../../data/redux/user/userSlice";
import { setStorageItem } from "../../../services/storage.service";
import "./style.scss";
interface SelectOwnerRoleModalProps {
  show: boolean;
  onHide: () => void;
  onSave: ({ isRealEstate }: any) => void;
}

const selectOwnerRoleModal: React.FC<SelectOwnerRoleModalProps> = ({
  show,
  onHide,
  onSave,
}) => {
  const dispatch: any = useDispatch();
  const [active, setActive] = useState("real");

  const handleSelect = (value: "real" | "nonreal") => {
    if (value === "real") {
      const newValue = true;
      dispatch(setIsRealEstate(newValue));
      setStorageItem("isRealEstate", JSON.stringify(newValue));
      setActive("real");
      onSave({ isRealEstate: newValue });
    } else {
      const newValue = false;
      dispatch(setIsRealEstate(newValue));
      setStorageItem("isRealEstate", JSON.stringify(newValue));
      setActive("nonreal");
      onSave({ isRealEstate: newValue });
    }
  };

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      // onHide={onHide}
      onHide={() => {}} // disable closing without selection
      backdrop="static" // disable closing on outside click
      keyboard={false} // disable ESC key close
      className="speedometerModal"
    >
      <Modal.Body className="text-center">
        <div className="speedometer_img">
          <img src="/assets/img/contract.png" alt="contract" />
        </div>
        <h4>Select Your Option</h4>
        <p>
          Select your work mode: track Real Estate hours or Non-Real Estate hours.
        </p>

        {/* <div className="d-flex flex-column gap-2">
          <label
            htmlFor="realEstateHours"
            className="radio_wrap"
            onClick={() => handleSelect("real")}
          >
            <p className="mb-0">Real Estate Hours</p>
            <input type="radio" id="realEstateHours" name="hours" />
          </label>

          <label
            htmlFor="nonrealEstateHours"
            className="radio_wrap"
            onClick={() => handleSelect("nonreal")}
          >
            <p className="mb-0">Non - Real Estate Hours</p>
            <input type="radio" id="nonrealEstateHours" name="hours" />
          </label>
        </div> */}
        <div className="toggle-container">
          <button
            className={`toggle-btn ${active === "real" ? "active" : ""}`}
            onClick={() => handleSelect("real")}
          >
            Real Estate
            <br />
            Hours
          </button>

          <button
            className={`toggle-btn ${active === "nonreal" ? "active" : ""}`}
            onClick={() => handleSelect("nonreal")}
          >
            Non - Real Estate
            <br />
            Hours
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default selectOwnerRoleModal;
